import Vue from 'vue'
import Router from 'vue-router'
import Settings from '@/components/Settings'
import Login from '@/components/Login'
import Scan from '@/components/Scan'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        anon: true
      }
    },
    {
      path: '/',
      name: 'Settings',
      component: Settings,
      meta: {
        auth: true
      }
    },
    {
      path: '/scan',
      name: 'Scan',
      component: Scan,
      meta: {
        auth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const authRequired = to.matched.some((route) => route.meta.auth)
  const anonRequired = to.matched.some((route) => route.meta.anon)
  const authed = store.state.apiKey
  if (authRequired && !authed) {
    next('/login')
  } else if (anonRequired && authed) {
    next('/')
  } else {
    next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js